import { render, staticRenderFns } from "./tabView.vue?vue&type=template&id=1d0c6ebe&"
import script from "./tabView.vue?vue&type=script&lang=js&"
export * from "./tabView.vue?vue&type=script&lang=js&"
import style0 from "./tabView.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports